// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1JMug","content":"LayoutSettings_content__l5s4j"};